import { render } from "./AppointmentDetail.vue?vue&type=template&id=58d6f7d9"
import script from "./AppointmentDetail.vue?vue&type=script&lang=js"
export * from "./AppointmentDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__